import React, { memo } from 'react';
import modules_7e6c94c2 from './pixel.module.scss.js';

const Pixel = memo(({ pixels }) => {
    if (!pixels)
        return null;
    const links = pixels.split(',');
    if (!links?.length)
        return null;
    return (React.createElement("div", { className: modules_7e6c94c2.pixels }, links.map((url) => (React.createElement("img", { src: url, className: modules_7e6c94c2.pixelImg, alt: "", key: `pixel-link-${url}` })))));
});

export { Pixel };
//# sourceMappingURL=index.js.map
